type ChatRoomTarget =
  | { type: 'dm'; otherUserId: number }
  | { type: 'custom-group'; groupId: number }
  | { type: 'story-group'; storyId: number };

type StoryScene<TElement extends Record<string, any> = Record<string, any>> = {
  id: number;
  scene_number: number;
  elements: TElement[];
};

type StoryPayload<TElement extends Record<string, any> = Record<string, any>> = {
  story_text?: string;
  scenes?: Array<StoryScene<TElement>>;
  [key: string]: any;
};

export const isE2eeEnabled = () => false;

export const ensureE2eeDeviceReady = async (_userId: number) => undefined;

export const encryptChatMessageForSend = async (
  _userId: number,
  _target: ChatRoomTarget,
  plaintext: string,
) => ({
  message: plaintext,
});

export const decryptChatMessagesForRoom = async <
  T extends {
    message: string;
  },
>(
  _userId: number,
  _target: ChatRoomTarget,
  messages: T[],
) => messages;

export const encryptStoryTextPayload = async (
  _userId: number,
  _storyId: number,
  storyText: string,
) => ({
  storyType: 'written' as const,
  storyText,
  fileName: null,
});

export const encryptScreenplayElementPayload = async (
  _userId: number,
  _storyId: number,
  characterName: string | null | undefined,
  content: string,
) => ({
  characterName: characterName || '',
  content,
});

export const decryptStoryPayload = async <
  TElement extends Record<string, any>,
  TStory extends StoryPayload<TElement>,
>(
  _userId: number,
  _storyId: number,
  story: TStory,
): Promise<TStory> => ({
  ...story,
  scenes: Array.isArray(story.scenes) ? [...story.scenes] : story.scenes,
});
